import { render, staticRenderFns } from "./SimpleCartIcon.vue?vue&type=template&id=27e8cce4&scoped=true"
import script from "./SimpleCartIcon.vue?vue&type=script&lang=js"
export * from "./SimpleCartIcon.vue?vue&type=script&lang=js"
import style0 from "./SimpleCartIcon.vue?vue&type=style&index=0&id=27e8cce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8cce4",
  null
  
)

export default component.exports